import InterviewReviewHeader from "./InterviewReviewHeader";
import InterviewReviewMain from "./InterviewReviewMain";
import InterviewReviewVideo from "./ReviewVideoPage/InterviewReviewVideo";
import { useSelector, useDispatch } from "react-redux";
import { openVideo } from "../../store/reviewReducer";


const InterviewReviewTab = ({ activeMenu }) => {
  const dispatch = useDispatch();
  const { openVideoReview } = useSelector((state) => state.review);

  const onTabClick = () => {
    dispatch(openVideo());
  };

  return (
    <>
      {openVideoReview ? (
        <>
          <InterviewReviewHeader />
          <InterviewReviewMain onClick={onTabClick} />
        </>
      ) : (
        <InterviewReviewVideo />
      )}
    </>
  );
};
export default InterviewReviewTab;
